/*
  This file is replaced in build time with school
  specific configurations from the `params` folder
 */
import { dayjsExtended } from "./utils";

export const ENDPOINT_LOCAL = "http://localhost:3001";
export const ENDPOINT = "https://z0vfc64ei9.execute-api.us-west-2.amazonaws.com/Prod";
export const COGNITO_USER_POOL_ID = "us-west-2_u6U38pjfT";
export const COGNITO_CLIENT_ID = "69o8hupbvmi74kd06cmd8hgr1p";
export const COGNITO_REGION = "us-west-2";
export const SITE_BANNER = "Lamping Giving Tree 2026";
export const EMAIL_SENDER = "Lamping Giving Tree";
const SCHOOL_NAME = "Lamping Elementary Campus";
const SCHOOL_ADDRESS = "2551 Summit Grove Dr. Henderson, NV 89052";
export const DEADLINE = "2026-12-4 18:00";
export const TIMEZONE = "America/Los_Angeles";
export const donationDeadline = dayjsExtended.tz(DEADLINE, TIMEZONE).format("MMM Do hA");
export const SUPPORT_EMAIL = "lamping@giving-trees.com";
export const SHOW_SPANISH = false;

export const INSTRUCTIONS = `Thank you for adopting a student this year for our Giving Tree.
First choose an ornament. Some ornaments are clothing and some ornaments are toys or requested gifts. Please fill out required information and when you submit you will receive a confirmation email with a donation id#. <mark>If you choose to buy clothing please purchase a full outfit. Donate one item or as many as makes you Merry.</mark>

Then return the gifts to the ${SCHOOL_NAME} located at ${SCHOOL_ADDRESS} as soon as possible or by the deadline ${donationDeadline}. Write on a gift tag the donation id# and attach to your gifts. <mark>This donation id# will be found on the email you will receive after you choose an ornament. Please do not wrap your gifts.</mark>`;

export const INSTRUCTIONS_ESP = ``;

export const DONATION_PRINTABLE = `Please make sure to drop off the donations at ${SCHOOL_NAME}’s front office no later than:

<strong>${donationDeadline}</strong>

<strong>Drop-off location:</strong>
${SCHOOL_ADDRESS}

Thank you for your giving hearts and participation.
Wishing you a <strong>Merry Christmas and Happy Holidays!</strong>
`;

export const SEPARATE_TOYS_APPAREL = true;
export const SCHOOL_OPTIONS = ["Lamping", "Wengart"];
export const TEACHER_GUARDIAN_INFO = true;
const FIREBASE_PROJECT = "lamping-tree";
